module.exports = __webpack_public_path__ + "img/oufu_90x110x10b.prt.bac37b36.jpg";